import { FC, Fragment } from "react";
import { cn } from "utils";
import { LottieLoading } from "@ospweb/sdk-ui";
import bigDecimal from "js-big-decimal";
import { Table } from "./Table";
import { OtherAssetProps } from "./types";
import Translations from "@translate/components/Portfolio/AssetInsight/InsightModal/otherAsset";
import { I18nUtil } from "@utils/i18n";
import NextImage from "@/src/components/NextImage";

const I18n = I18nUtil.createScoped(Translations);

export const OtherAsset: FC<OtherAssetProps> = ({ className, topAssets }) => {
  const handleEndReached = () => {};
  return (
    <Table
      onEndReachedThreshold="100"
      // noMoreContainerClassName="h-20"
      hasNextPage={false}
      onEndReached={handleEndReached}
      renderLoading={
        <div className={cn("flex flex-col items-center justify-end pt-4 pb-1")}>
          <LottieLoading style={{ width: 20, height: 20 }} />
        </div>
      }
      className={cn("grid-cols-[33%_1fr_23%] h-fit overflow-y-auto", className)}
      data={topAssets || []}
      columns={[
        {
          key: "symbol",
          header: {
            label: I18n.t("Assets"),
            className:
              "sticky top-0 shadow-[inset_0_1px_0_0_var(--edgen-border\_solid),0_1px_0_0_var(--edgen-border\_solid)]",
          },
          attributes: (item) => {
            return {
              className: cn("gap-2"),
              children: (
                <Fragment>
                  <NextImage
                    src={item.logo}
                    width={24}
                    height={24}
                    className="border rounded-full border-solid border-border_solid"
                  />
                  <span>{item.symbol}</span>
                </Fragment>
              ),
            };
          },
        },
        {
          key: "value",
          header: {
            label: I18n.t("Value"),
            className:
              "sticky top-0 shadow-[inset_0_1px_0_0_var(--edgen-border\_solid),0_1px_0_0_var(--edgen-border\_solid)]",
          },
          attributes: (item) => {
            return {
              className: cn("body_bold_m"),
              children: `$${bigDecimal.round(
                item.totalValue || "0",
                2,
                bigDecimal.RoundingModes.DOWN,
              )}`,
            };
          },
        },
        {
          key: "proportion",
          header: {
            label: I18n.t("Proportion"),
            className:
              "sticky top-0 shadow-[inset_0_1px_0_0_var(--edgen-border\_solid),0_1px_0_0_var(--edgen-border\_solid)]",
          },
          attributes: (item) => {
            return {
              children: `${bigDecimal.round(
                item.value || "0",
                2,
                bigDecimal.RoundingModes.DOWN,
              )}%`,
            };
          },
        },
      ]}
    />
  );
};
